export const FORM_STATUS = {
  DRAFT: 'draft',
  LIVE: 'live',
  DELETED: 'deleted'
};

export const FORM_EDITOR_MODE = {
  EDIT_FORM: 'editForm',
  EDIT_FIELD: 'editField',
  ADD_FIELD: 'addField'
};

export const FORM_PRIVACY = {
  TEAM: 'team',
  PUBLIC: 'public'
};

export const STRING_FIELD_TYPES = {
  SHORT_TEXT: {
    value: 'shortText',
    label: 'Short text'
  },
  PARAGRAPH: {
    value: 'paragraph',
    label: 'Paragraph'
  },
  DATE: {
    value: 'date',
    label: 'Date'
  },
  NUMBER: {
    value: 'number',
    label: 'Number'
  }
};

export const FIELD_TYPES = {
  SHORT_TEXT: 'shortText',
  PARAGRAPH: 'paragraph',
  DATE: 'date',
  NUMBER: 'number',
  SELECT: 'select',
  CHECKBOXES: 'checkboxes',
  SINGLE_FILE: 'singleFile',
  MULTIPLE_FILES: 'multipleFiles'
};

export const RECAPTCHA_SECRET = '6Ld_ttMUAAAAAK6NnxObI5bw6ewYlEyHblpiGHWV';

export const ROUTES = {
  BASE: '/',
  EDIT: '/edit/:formId'
};

// Allow any https URL (with or without image extensions). Cloudinary will validate/fetch.
export const IMAGE_URL_EXP = /^https:\/\/[^\s]+$/i;
